import React, { useRef, useState } from "react";
import Slider from "react-slick";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Container, Row, Col } from "react-bootstrap";
import AnimateOnScroll from "../AnimateOnScroll/AnimateOnScroll";
import ImageLoader from "../ImageLoader/ImageLoader";
import { useTranslation } from "react-i18next";

const ApartmentsAndPlans = () => {
  const { t } = useTranslation();
  const sliderRef = useRef(null);
  const sliderRef2 = useRef(null);
  const sliderRef3 = useRef(null);

  const [lightbox, setLightbox] = useState({
    open: false,
    slides: [],
    index: 0,
  });

  const openLightbox = (slides, index) => {
    setLightbox({
      open: true,
      slides,
      index,
    });
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: "0px",
    arrows: false, // We are using custom arrows
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const slider1Content = [
    <div className="image-card" key={0}>
      <img src="/images/DDK_0612p.jpg" alt="" />
    </div>,
    <div className="image-card" key={1}>
      <img src="/images/DDK_0809pppp.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/grand_oasis_extra_01.jpeg" alt="" />
    </div>,
    <div className="image-card" key={3}>
      <img src="/images/grand_oasis_extra_03.jpeg" alt="" />
    </div>,
    <div className="image-card" key={4}>
      <img src="/images/grand_oasis_extra_02.jpeg" alt="" />
    </div>,
  ];

  const slider2Content = [
    <div className="image-card" key={0}>
      <img src="/images/sky_02.jpg" alt="" />
    </div>,
    <div className="image-card" key={1}>
      <img src="/images/sky_03.jpg" alt="" />
    </div>,
    <div className="image-card" key={3}>
      <img src="/images/sky_07.jpg" alt="" />
    </div>,
    <div className="image-card" key={4}>
      <img src="/images/sky_04.jpg" alt="" />
    </div>,
  ];

  const slider3Content = [
    <div className="image-card" key={0}>
      <img src="/images/one_oasis_01.jpg" alt="" />
    </div>,
    <div className="image-card" key={1}>
      <img src="/images/one_oasis_02.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/one_oasis_03.jpg" alt="" />
    </div>,
  ];

  const slides1 = slider1Content.map((card) => ({
    src: card.props.children.props.src,
  }));
  const slides2 = slider2Content.map((card) => ({
    src: card.props.children.props.src,
  }));
  const slides3 = slider3Content.map((card) => ({
    src: card.props.children.props.src,
  }));

  return (
    <ImageLoader>
      <Container>
        <Row className="section">
          <AnimateOnScroll animationType="slideUp">
            <h2>{t("apartments_main_title")}</h2>
            <p>{t("apartments_main_p")}</p>
            <video autoPlay muted loop style={{ width: "100%" }}>
              <source
                src="/images/videos/Oasis apartments models.mp4"
                type="video/mp4"
              />
            </video>
          </AnimateOnScroll>
        </Row>
        <Row className="section">
          <Row className="g-0">
            <Col md={6}>
              <AnimateOnScroll animationType="slideLeft">
                <img
                  src="/images/pic_08.jpg"
                  alt="One Oasis"
                  className="fullimg "
                />
              </AnimateOnScroll>
            </Col>
            <Col md={6}>
              <AnimateOnScroll animationType="slideRight">
                <h2>{t("apartments_grand_oasis_title")}</h2>
                <p>{t("apartments_grand_oasis_p")}</p>
                <a className="btn btn-primary" href="/grandoasis-floorplan">
                  {t("apartments_floor_plan_btn")}
                </a>
              </AnimateOnScroll>
            </Col>
          </Row>
          <Row className="g-0">
            <Col md={6}></Col>
            <Col md={6}>
              <AnimateOnScroll animationType="slideUp">
                <div className="sigle-slider ">
                  <Slider ref={sliderRef} {...sliderSettings}>
                    {slider1Content.map((card, idx) =>
                      React.cloneElement(card, {
                        onClick: () => openLightbox(slides1, idx),
                      })
                    )}
                  </Slider>
                  <div className="slider-arrows">
                    <button
                      className="slick-prev-custom"
                      onClick={() => sliderRef.current.slickPrev()}
                    >
                      <FaArrowLeft />
                    </button>
                    <button
                      className="slick-next-custom"
                      onClick={() => sliderRef.current.slickNext()}
                    >
                      <FaArrowRight />
                    </button>
                  </div>
                </div>
              </AnimateOnScroll>
            </Col>
          </Row>
        </Row>

        <Row className="section">
          <Col md={7} className="d-flex flex-column justify-content-center">
            <AnimateOnScroll animationType="slideUp">
              <h2>{t("apartments_sky_oasis_title")}</h2>
              <p
                dangerouslySetInnerHTML={{
                  __html: t("apartments_sky_oasis_p"),
                }}
              ></p>
              <div>
                <a className="btn btn-primary" href="/skyoasis-floorplan">
                  {t("apartments_floor_plan_btn")}
                </a>
              </div>
            </AnimateOnScroll>
            <br />
            <br />

            <AnimateOnScroll animationType="slideUp">
              <div className="sigle-slider ">
                <Slider ref={sliderRef2} {...sliderSettings}>
                  {slider2Content.map((card, idx) =>
                    React.cloneElement(card, {
                      onClick: () => openLightbox(slides2, idx),
                    })
                  )}
                </Slider>
                <div className="slider-arrows">
                  <button
                    className="slick-prev-custom"
                    onClick={() => sliderRef2.current.slickPrev()}
                  >
                    <FaArrowLeft />
                  </button>
                  <button
                    className="slick-next-custom"
                    onClick={() => sliderRef2.current.slickNext()}
                  >
                    <FaArrowRight />
                  </button>
                </div>
              </div>
            </AnimateOnScroll>
          </Col>
          <Col md={5}>
            <AnimateOnScroll animationType="slideLeft">
              <img
                src="/images/sky_01.jpg"
                alt="One Oasis"
                className="fullimg "
              />
            </AnimateOnScroll>
          </Col>
        </Row>

        <Row className="section">
          <Row className="d-flex flex-column-reverse flex-md-row">
            <Col md={7}>
              <AnimateOnScroll animationType="slideUp">
                <div className="sigle-slider ">
                  <Slider ref={sliderRef3} {...sliderSettings}>
                    {slider3Content.map((card, idx) =>
                      React.cloneElement(card, {
                        onClick: () => openLightbox(slides3, idx),
                      })
                    )}
                  </Slider>
                  <div className="slider-arrows">
                    <button
                      className="slick-prev-custom"
                      onClick={() => sliderRef3.current.slickPrev()}
                    >
                      <FaArrowLeft />
                    </button>
                    <button
                      className="slick-next-custom"
                      onClick={() => sliderRef3.current.slickNext()}
                    >
                      <FaArrowRight />
                    </button>
                  </div>
                </div>
              </AnimateOnScroll>
            </Col>
            <Col md={5} className="d-flex flex-column justify-content-center">
              <AnimateOnScroll animationType="slideUp">
                <h2>{t("apartments_one_oasis_title")}</h2>
                <p>{t("apartments_one_oasis_p")}</p>
                <div></div>
              </AnimateOnScroll>
            </Col>
          </Row>
        </Row>
        <Lightbox
          open={lightbox.open}
          close={() => setLightbox({ ...lightbox, open: false })}
          slides={lightbox.slides}
          index={lightbox.index}
        />
      </Container>
    </ImageLoader>
  );
};

export default ApartmentsAndPlans;
